<app-navbar></app-navbar>
<div class="container-fluid main-container">
    <div id="body"></div>
    <!--<app-footer></app-footer>-->

</div>
<app-footer></app-footer>
